exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".breadcrumb{border-bottom:0 !important;background:none !important;margin-bottom:10px !important}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/breadcrumb/style.scss
// module id = 1846
// module chunks = 32